
const state = {
  loadingOverlay: false,
  inLoginProcess: false,
  loginSuccess: false
}

const mutations = {
  setLoadingOverlay (state, status) {
    state.loadingOverlay = status
  },
  setInLoginProcess (state, status) {
    state.inLoginProcess = status
  },
  setLoginSuccess (state, status) {
    state.loginSuccess = status
    localStorage.setItem('loginSuccess', JSON.stringify(status))
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
